
<div class="app-selector" ngbDropdown>
  <button ngbDropdownToggle type="button" class="btn btn-outline-secondary dropdown-toggle btn-rounded" (click)='ClickCbo()'>
    <ng-container *ngIf="!selectedTemplateRef">
      {{ picked?.name || label }}
    </ng-container>

    <ng-container
      *ngIf="selectedTemplateRef"
      [ngTemplateOutlet]="selectedTemplateRef"
      [ngTemplateOutletContext]="{ $implicit: picked }"
    >
    </ng-container>
    <span class="caret"></span>
    <i class="mdi mdi-chevron-down"></i> 
  </button>

  <ul ngbDropdownMenu class="dropdown-menu">
    <li
      *ngFor="let option of options; index as i"
      (click)="selectOption(option)"
    >
      <ng-container *ngIf="!optionTemplateRef">
        <a class="dropdown-item">
          {{ option?.name || option }}
        </a>
      </ng-container>

      <ng-container
        *ngIf="optionTemplateRef"
        [ngTemplateOutlet]="optionTemplateRef"
        [ngTemplateOutletContext]="{ $implicit: option, index: i }"
      >
      </ng-container>
    </li>
  </ul>
</div>

